/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-11-15 11:18:17
 * @LastEditors: linxi
 * @LastEditTime: 2025-10-17 16:49:20
 */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { sendAsync } from '../../../../app/applicationSlice'
import { RootThunkApi } from '../../../../app/store'
import { getMemorandumExcelFn, getPatientMemoDelete, getPatientMemoDetail, getPatientMemoList, getPatientMemoSubmit, ImportExcelParams, PatientMemoDeleteParams, PatientMemoDetailParams, PatientMemoListParams, PatientMemoSubmitParams } from '../../../../services/memorandum'

// 获取列表
export const getPatientMemoListAsync = createAsyncThunk<
  void,
  PatientMemoListParams,
  RootThunkApi<void>
>('memorandum/getPatientMemoListAsync', async (params, api) => {
  return sendAsync(getPatientMemoList(params), api)
})

// 详情
export const getPatientMemoDetailAsync = createAsyncThunk<
  void,
  PatientMemoDetailParams,
  RootThunkApi<void>
>('memorandum/getPatientMemoDetailAsync', async (params, api) => {
  return sendAsync(getPatientMemoDetail(params), api)
})

// 保存
export const getPatientMemoSubmitAsync = createAsyncThunk<
  void,
  PatientMemoSubmitParams,
  RootThunkApi<void>
>('memorandum/getPatientMemoSubmitAsync', async (params, api) => {
  return sendAsync(getPatientMemoSubmit(params), api)
})

// 删除
export const getPatientMemoDeleteAsync = createAsyncThunk<
  void,
  PatientMemoDeleteParams,
  RootThunkApi<void>
>('memorandum/getPatientMemoDeleteAsync', async (params, api) => {
  return sendAsync(getPatientMemoDelete(params), api)
})

// 导入 excel
export const getMemorandumExcelAsync = createAsyncThunk<
  void,
  ImportExcelParams,
  RootThunkApi
>('/commodity/getpatientsExcel', async (body, api) => {
  return sendAsync(getMemorandumExcelFn(body), api)
})